import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, style, animate, transition } from '@angular/animations';
import { MessageService } from '../../../core/services/message.service';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class MessageComponent implements OnInit, OnDestroy {
  successMessage = '';
  errorMessage = '';
  showSuccess = false;
  showError = false;

  private destroy$ = new Subject<void>();

  constructor(private readonly messageService: MessageService) {}

  ngOnInit(): void {
    this.messageService.successMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(message => {
        this.successMessage = message;
        this.showSuccess = message !== '';
      });

    this.messageService.errorMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(message => {
        this.errorMessage = message;
        this.showError = message !== '';
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeSuccess(): void {
    this.showSuccess = false;
    this.successMessage = '';
  }

  closeError(): void {
    this.showError = false;
    this.errorMessage = '';
  }
}
